import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import scrollIntoView from "scroll-into-view-if-needed";
import NextLink from "next/link";
import { useElementId } from "../../../runtimes/react";
import { usePagePathnameSlice } from "../../../runtimes/react/hooks/makeswift-api";
const Link = forwardRef(function Link2({ link, onClick = () => {
}, ...restOfProps }, ref) {
  const pageId = link && link.type === "OPEN_PAGE" ? link.payload.pageId : null;
  const page = usePagePathnameSlice(pageId ?? null);
  const elementKey = link?.type === "SCROLL_TO_ELEMENT" ? link.payload.elementIdConfig?.elementKey : null;
  const elementId = useElementId(elementKey);
  let useNextLink;
  let href;
  let target;
  let block;
  if (link) {
    switch (link.type) {
      case "OPEN_PAGE": {
        if (page) {
          useNextLink = true;
          href = `/${page.pathname}`;
        }
        target = link.payload.openInNewTab ? "_blank" : "_self";
        break;
      }
      case "OPEN_URL": {
        useNextLink = true;
        href = link.payload.url;
        target = link.payload.openInNewTab ? "_blank" : "_self";
        break;
      }
      case "SEND_EMAIL": {
        useNextLink = false;
        const { to, subject = "", body = "" } = link.payload;
        if (to != null)
          href = `mailto:${to}?subject=${subject}&body=${body}`;
        break;
      }
      case "CALL_PHONE": {
        useNextLink = false;
        href = `tel:${link.payload.phoneNumber}`;
        break;
      }
      case "SCROLL_TO_ELEMENT": {
        useNextLink = false;
        href = `#${elementId ?? ""}`;
        block = link.payload.block;
        break;
      }
      default:
        throw new RangeError(`Invalid link type "${link.type}."`);
    }
  }
  function handleClick(event) {
    onClick(event);
    if (event.defaultPrevented)
      return;
    if (event.currentTarget.isContentEditable)
      return event.preventDefault();
    if (link && link.type === "SCROLL_TO_ELEMENT") {
      let hash;
      try {
        if (href != null)
          hash = new URL(`http://www.example.com/${href}`).hash;
      } catch (error) {
        console.error(`Link received invalid href: ${href}`, error);
      }
      if (href != null && hash != null && href === hash) {
        event.preventDefault();
        const view = event.view;
        scrollIntoView(view.document.querySelector(hash), {
          behavior: "smooth",
          block
        });
        if (view.location.hash !== hash)
          view.history.pushState({}, "", hash);
      }
    }
  }
  if (useNextLink && href != null) {
    return /* @__PURE__ */ jsx(
      NextLink,
      {
        ...restOfProps,
        ref,
        target,
        onClick: handleClick,
        href,
        legacyBehavior: false
      }
    );
  }
  return /* @__PURE__ */ jsx("a", { ...restOfProps, ref, href, target, onClick: handleClick });
});
export {
  Link
};
//# sourceMappingURL=index.js.map